<template>
  <div>
    <div v-if="merchant.logo" class="pb-2">
      <v-img contain max-height="50px" min-height="50px" max-width="200px" min-width="200px" position="left center" :src="imageUrl + '/' + merchant.logo"/>
    </div>
      <div class="d-block py-2">
        <label type="button" for="logo-input" class="pr-5"><v-icon small class="mr-2">fa-upload</v-icon>{{merchant.logo ? "Update" : "Add" }} Merchant Logo</label>
        <input id="logo-input" type="file" accept="image/*" @change="addFile" style="display: none">
    </div>
  </div>
</template>

<script>
import ApiMixin from '@/mixins/api'

export default {
  mixins: [ApiMixin],
  props: {
    merchant: Object
  },
  data: function () {
    return {
      imageUrl: process.env.VUE_APP_IMAGE_URL,
      file: null
    }
  },
  methods: {
    async addFile (event) {
      const file = event.target.files[0]
      this.file = file
      if (confirm(`Are you sure you wish to add ${file.name} as the new logo for ${this.merchant.name}?`)) {
        await this.submitFile()
        this.file = null
      } else {
        this.file = null
      }
    },

    async submitFile () {
      const response = await this.getS3SecuredUrl()
      if (response) {
        const {url} = response.data
        await this.uploadImageToS3Bucket(url, this.file)
        await this.addImageToDataBase(url)
      } else {
        console.error('Logo failed to upload')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/manage/MerchantImageManagement.vue